import { fetchContentFragmentsFromCms } from '@msc-b2c/shared-utils';

import { IGetSpecialtyRestaurantBundleResponse } from '@msc-b2c/interfaces/types';

export function getRestaurantInfoFromGraphql() {
  return fetchContentFragmentsFromCms<IGetSpecialtyRestaurantBundleResponse, undefined>(
    'getBundleRestaurants'
  )
    .then((result) => {
      const data = result.data.specialtyRestaurantList.items;
      if (!data) {
        return;
      }
      return data;
    })
    .catch((error) => {
      console.error('error fetching restaurant bundle from content fragments', error);
    });
}
